import Masterconfig from './Masterconfig.js'
import axios from 'axios'

const Fly = {
  install (Vue, options) {
    Vue.mixin({
      created: function () {
        this.masterconfig = new Masterconfig()
      },
      methods: {
        flyGet: function (path) {
          return axios.get(this.masterconfig.baseLink(path))
        },
        flyPost: function (path, dataArray) {
          return axios.post(this.masterconfig.baseLink(path), dataArray)
        },
        flyGetSession: function (path) {
          var o = {
            access_id: this.getSessionItem('id_token'),
            access_token: this.getSessionItem('access_token')
          }
          return axios.post(this.masterconfig.baseLink(path), o)
        },
        flyPostSession: function (path, dataArray) {
          var postData = JSON.stringify(dataArray)
          var o = {
            access_id: this.getSessionItem('id_token'),
            access_token: this.getSessionItem('access_token'),
            post_data: postData
          }
          return axios.post(this.masterconfig.baseLink(path), o)
        },
        flyGetSessionV2: function (path) {
          var objFormData = new FormData()
          objFormData.append('access_id', this.getSessionItem('id_token'))
          objFormData.append('access_token', this.getSessionItem('access_token'))
          return axios.post(this.masterconfig.baseLink(path), objFormData)
        },
        flyPostSessionV2 (path, dataArray) {
          var objFormData = new FormData()
          var postData = JSON.stringify(dataArray)
          objFormData.append('access_id', this.getSessionItem('id_token'))
          objFormData.append('access_token', this.getSessionItem('access_token'))
          objFormData.append('post_data', postData)
          return axios.post(this.masterconfig.baseLink(path), objFormData)
        },
        flyPostFileSession (path, dataArray = '', dataFile = '', dataMultiFile = '') {
          var objFormData = new FormData()
          var postData = JSON.stringify(dataArray)
          objFormData.append('access_id', this.getSessionItem('id_token'))
          objFormData.append('access_token', this.getSessionItem('access_token'))
          objFormData.append('post_data', postData)

          if (dataFile !== '') {
            for (var name in dataFile) {
              objFormData.append(name, dataFile[name])
            }
          }

          if (dataMultiFile !== '') {
            for (var nameMultiple in dataMultiFile) {
              for (var index in dataMultiFile[nameMultiple]) {
                objFormData.append(nameMultiple + '[]', dataMultiFile[nameMultiple][index])
              }
            }
          }

          return axios.post(this.masterconfig.baseLink(path), objFormData, this.postConfig)
        }
      }
    })
  }
}

export default Fly



// WEBPACK FOOTER //
// ./src/library/Fly.js